<template>
  <section>
    <qx-search-box
      class="searchBox"
      ref="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery
    >
      <div slot="waitDeal" slot-scope="prop">
        <el-checkbox label="待我处理" name="type" v-model="prop.form.waitDeal" />
      </div>
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getSysStaticDataByCodeType,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        rechargeStateOptions: [],
        etcCardTypeOptions: [],
        form: [
          { // 待我处理
            label: '',
            value: 'waitDeal',
            default: true,
            slot: true,
            class: 'next-search-btn',
          },
          {
            label: '',
            value: 'rechargeState',
            type: 'radio',
            default: -1,
            class: 'especial-radio-group',
            normalFormNotCount: true,
            onChangeRadio: () => {
              this.$refs.searchBox.sub();
            },
          },
          {
            label: '申请时间',
            value: 'Time',
            type: 'date',
            default: [],
            placeholder: '请选择申请时间',
            attr: {
              type: 'datetimerange',
            },
          },
          {
            label: '申请人',
            value: 'applyUserName',
            type: 'input',
            placeholder: '请输入申请人',
          },
          {
            label: '卡类型',
            value: 'etcCardType',
            type: 'select',
            default: -1,
            placeholder: '请输入卡类型',
          },
          {
            label: '车牌号',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号',
          },
          {
            label: 'ETC卡号',
            value: 'etcCardNum',
            type: 'input',
            placeholder: '请输入ETC卡号',
          },
        ],
      },
    };
  },
  watch: {
    '$route.query.etcCardNum': function () {
      this.jumpHereSearch();
    },
  },
  methods: {

    jumpHereSearch (searchBoxData) {
      const etcCardNum = this.$route.query.etcCardNum;
      if (etcCardNum) {
        this.$refs.searchBox.setVal('etcCardNum', etcCardNum);
        if (searchBoxData) {
          searchBoxData.etcCardNum = etcCardNum;
        }
      }
    },

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      if (searchBoxData.Time && searchBoxData.Time[0]) { // 发车时间
        searchBoxData.startApplyTime = this.formatDate(searchBoxData.Time[0], 1);
        searchBoxData.endApplyTime = this.formatDate(searchBoxData.Time[1], 1);
      }
      delete searchBoxData.Time;

      this.jumpHereSearch(searchBoxData);

      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const rechargeStateOptions = await getSysStaticDataByCodeType({
      codeType: 'ETC_ENTITY_RECHARGE_STATE',
    });
    const etcCardTypeOptions = await getSysStaticDataByCodeType({
      codeType: 'ETC_CARD_TYPE',
    });
    this.searchBoxData.rechargeStateOptions = [
      { label: '全部', value: -1 },
      ...rechargeStateOptions,
    ];
    this.searchBoxData.etcCardTypeOptions = [
      { label: '全部', value: -1 },
      ...etcCardTypeOptions,
    ];
    this.jumpHereSearch();
  },
};
</script>

<style lang="scss" scoped>
::v-deep .next-search-btn {
  position: absolute;
  left: calc(100% - 315px);
  top: 110px;
  width: 100px !important;
}
</style>
